import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async submitAndFollow(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const form = this.element;

    if (link.dataset.submitting === "true") return;
    link.dataset.submitting = "true";
    link.setAttribute("aria-busy", "true");
    link.classList.add("disabled");

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;
      const saveResponse = await fetch(form.action, {
        method: form.method.toUpperCase(),
        body: new FormData(form),
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken,
        },
      });
      const saveStream = await saveResponse.text();
      window.Turbo.renderStreamMessage(saveStream);

      if (!saveResponse.ok) return;

      const followResponse = await fetch(link.href, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
      });
      const followStream = await followResponse.text();
      window.Turbo.renderStreamMessage(followStream);
    } catch (error) {
      console.error("submit-before-follow failed:", error);
      const message = link.dataset.errorMessage || "Something went wrong. Please try again.";
      window.Turbo.renderStreamMessage(
        `<turbo-stream action="append" target="flash"><template><div class="alert alert-dismissible alert-danger my-3 fade show" role="alert">${message}<button type="button" class="btn-close pe-3" data-bs-dismiss="alert" aria-label="Close"></button></div></template></turbo-stream>`,
      );
    } finally {
      delete link.dataset.submitting;
      link.removeAttribute("aria-busy");
      link.classList.remove("disabled");
    }
  }
}
